import { Feather } from "@expo/vector-icons";
import _ from "lodash";
import { observer } from "mobx-react";
import React, { useEffect, useRef, useState } from "react";
import {
  ActivityIndicator,
  Dimensions,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  View,
  Image,
  TextInput,
} from "react-native";
import { Button, SearchBar } from "react-native-elements";
import { RFValue } from "react-native-responsive-fontsize";
import { Row, Table } from "react-native-table-component";
import CustomHeader from "../../components/CustomHeader";
import CloseIcon from "../../components/icons/CloseIcon";
import MenuIcon from "../../components/icons/MenuIcon";
import getApprovedApplications from "../../networking/api/notarize/getApprovedApplications";
import { navigate } from "../../routes/Global";
import state from "../../store/Store";

const { height, width } = Dimensions.get("window");

const SearchDocuments = observer(({ navigation }) => {
  const [items, setItems] = useState([]);
  const [cloned, setCloned] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    getApprovedApplications(
      state.uid,
      (e) => {
        setItems(e);
        setCloned(e);
      },
      (e) => setLoading(e),
      state.accessToken
    );
  }, []);

  const tableHead = [
    "#",
    "Full Name",
    "Image",
    "Email Address",
    "Firebase Reference No.",
    <View style={styles.headerRow}>
      <Text style={styles.headerAltText}>Already Own License?</Text>
      <View>
        <Feather
          name="chevron-up"
          size={16}
          color="black"
          onPress={() => setItems(_.orderBy(items, "hasAlreadyLicense"))}
        />
        <Feather
          name="chevron-down"
          size={16}
          color="black"
          onPress={() => setItems(_.orderBy(items, "hasAlreadyLicense", "desc"))}
        />
      </View>
    </View>,
    "Status",
    "View Profile",
  ];

  const tableData = cloned?.map((record, index) => {
    let number = index + 1;
    const { firstName, lastName, hasAlreadyLicense, key, currentReq, result, email, image } = record || {};
    let source = image ? { uri: image } : require("../../assets/user.png");
    return [
      number,
      firstName + " " + lastName,
      <Image source={source} style={styles.image} resizeMode="contain" />,
      email,
      key,
      hasAlreadyLicense ? "YES" : "NO",
      result,
      <Button
        title="View"
        buttonStyle={styles.buttonStyle}
        titleStyle={styles.buttonTitle}
        onPress={() => navigate("viewnotarizedetails", { item: record })}
      />,
    ];
  });

  const searchFilter = (searchText) => {
    setSearch(searchText);
    let uppercaseText = searchText.toUpperCase().replace(/ +/g, "");
    let filteredData = items.filter((item) => {
      let firstName = item.firstName.toUpperCase();
      let lastName = item.lastName.toUpperCase();
      let email = item.email.toUpperCase();
      let key = item.key.toUpperCase();
      return (
        email.includes(uppercaseText) ||
        firstName.includes(uppercaseText) ||
        lastName.includes(uppercaseText) ||
        key.includes(uppercaseText) ||
        (firstName + lastName).includes(uppercaseText)
      );
    });

    setCloned(filteredData);
  };

  const scrollRef = useRef();

  let flexArr = tableHead.map((o, i) => (i === 0 ? 0.25 : [2, 5].includes(i) ? 0.5 : i === 3 ? 1.25 : 1));

  return (
    <View style={styles.container}>
      {/* <Text
        onPress={() => navigate("notarizedispute")}
        style={[styles.headerText, styles.dispute]}
      >
        View Disputes
      </Text> */}
      <CustomHeader title="Search Documents" leftIcon={<MenuIcon navigation={navigation} />} />

      <SearchBar
        placeholder="Enter name, email address, or reference number"
        onChangeText={(e) => searchFilter(e)}
        value={search}
        inputStyle={styles.inputStyle}
      />
      <Table>
        <Row data={tableHead} style={styles.head} textStyle={styles.headerText} flexArr={flexArr} />
        <ScrollView
          ref={scrollRef}
          nestedScrollEnabled={true}
          contentContainerStyle={styles.scrollView}
          bounces={false}
          showsVerticalScrollIndicator={false}>
          {loading ? (
            <ActivityIndicator animating size="large" />
          ) : (
            <Table>
              {tableData?.map((rowData, index) => (
                <View key={rowData + index.toString()}>
                  <Row data={rowData} style={styles.row} textStyle={styles.text} flexArr={flexArr} />
                  <View style={styles.borderLine} />
                </View>
              ))}
            </Table>
          )}
        </ScrollView>
      </Table>
    </View>
  );
});

export default SearchDocuments;

const styles = StyleSheet.create({
  inputStyle: { paddingHorizontal: 10, fontFamily: "avenir", outlineWidth: 0 },
  headerAltText: { fontFamily: "avenir", fontSize: RFValue(9) },
  headerRow: { alignItems: "center", flexDirection: "row", margin: 6 },
  notFound: {
    fontFamily: "avenir-h",
    fontSize: RFValue(22),
    textAlign: "center",
    color: "gray",
  },
  rowView: {
    flexDirection: "row",
    alignItems: "center",
  },
  buttonTitle: { fontSize: RFValue(9), fontFamily: "avenir" },
  buttonStyle: {
    width: width * 0.08,
    marginBottom: 2.5,
    paddingVertical: 5,
    borderRadius: 10,
    backgroundColor: "#2E3339",
  },
  borderLine: { borderBottomWidth: 0.5 },
  view: { marginBottom: height * 0.025, flex: 1 },
  tableStyle: { borderColor: "transparent" },
  scrollView: { flexGrow: 0, paddingBottom: height * 0.05 },
  imageStyle: {
    width: 35,
    height: 35,
    borderRadius: 35 / 2,
  },
  container: {
    flex: 1,

    backgroundColor: "#fff",
  },
  head: { backgroundColor: "#ECECF4", flexGrow: 0 },
  text: { margin: 6, fontSize: RFValue(9), fontFamily: "avenir" },
  dispute: { alignSelf: "flex-end", textDecorationLine: "underline" },
  headerText: {
    margin: 6,
    fontSize: RFValue(9),
    fontFamily: "avenir",
  },
  row: { flexDirection: "row", backgroundColor: "white", marginTop: 10 },
  image: { width: 50, height: 50, borderRadius: 25, borderWidth: 1, borderColor: "#d3d3d3" },
  textStyle: { fontFamily: "avenir", fontSize: RFValue(10) },
});
